import { useGetStatsQuery } from '@platform/state/api';
import type { IMenuEntry } from './IMenuEntry';
import { countParamsOf } from './menuEntries';

/**
 * Живий лічильник пункту меню: готовий (статуси й значення поля — з фасетів) або `total` статистики з пресетом і фільтром пункту.
 * Спільний кеш RTK Query: «Усі» — той самий запит, що й лічильники статусів; зміни записів інвалідовують статистику типу. `enabled` = false —
 * пункт без лічильника (без запиту).
 */
export function useEntryCount(ws: string, rtKey: string, entry: IMenuEntry, enabled = true): number | undefined {
  const params = enabled ? countParamsOf(entry) : null;
  const { data } = useGetStatsQuery({ ws, rt: rtKey, by: 'status', params: params ?? {} }, { skip: !params });
  if (!enabled) return undefined;
  return entry.count ?? (params ? data?.total : undefined);
}
